import { inject, Injectable, signal } from '@angular/core';
import { Resolve } from '@angular/router';
import { StoreInterfaceService } from '../services/store-interface.service';
import { PolynomialModelStore } from '../stores/polynomial-model.store';
import { UnitStore } from '../stores/unit.store';
import { FormulaModelType, PolynomialModel, PolynomialModelsResolvedData } from '../types/formula.interface';
import { Unit } from '../types/unit.interface';

@Injectable({
  providedIn: 'root',
})
export class PolynomialModelsResolver implements Resolve<PolynomialModelsResolvedData> {
  private readonly unitsStore = inject(UnitStore);
  private readonly polynomialModelsStore = inject(PolynomialModelStore);
  private readonly storeService = inject(StoreInterfaceService);

  async resolve(): Promise<PolynomialModelsResolvedData> {
    const dataLoaded = signal(false);
    void this.unitsStore.loadAll().then(() => {
      void this.polynomialModelsStore.loadAll().then(() => {
        dataLoaded.set(true);
      });
    });
    return {
      formulaModels: this.storeService.getData<PolynomialModel>('PolynomialModel'),
      units: this.storeService.getData<Unit>('Unit'),
      dataLoaded,
      formulaModelType: FormulaModelType.CHECKER,
    };
  }
}
